import React from 'react';
import Wrapper from './Wrapper';

export default ({ children, ...rest }) => <Wrapper {...rest}>{children}</Wrapper>;
